import * as Yup from 'yup';

export const reportListSchema = Yup.object({
  Description: Yup.string().required('Description is required'),
});
